var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEscolaIcone = function SvgEscolaIcone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000976562 3.91535C0.000976562 3.31455 0.383115 2.78115 0.94966 2.59116L8.36852 0.103254C8.77906 -0.0344182 9.2229 -0.0344178 9.63343 0.103254L16.6334 2.4507C17.4501 2.72457 18.001 3.49347 18.001 4.35954V13.9758L19.7673 16.0181C20.1801 16.5165 20.0231 17.2719 19.4463 17.562L19.209 17.6814C18.7925 17.8909 18.2585 18 17.7928 18H17.2092C16.7434 18 16.2841 17.8909 15.8675 17.6814L15.6303 17.562C15.0535 17.2719 14.8965 16.5165 15.3093 16.0181L17.001 13.9758V5.25674L9.63343 7.72744C9.2229 7.86511 8.77905 7.86511 8.36852 7.72744L0.949658 5.23953C0.383114 5.04954 0.000976562 4.51615 0.000976562 3.91535Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00098 7L8.40132 9.01154C8.79168 9.13422 9.21027 9.13422 9.60063 9.01154L16.001 7V11.8667C16.001 11.8667 14.8343 14 9.00098 14C3.16764 14 2.00098 11.8667 2.00098 11.8667V7Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEscolaIcone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/escola-icone.9a821ffa.svg";
export { ForwardRef as ReactComponent };